import { getDataMapper, mapArray, mapField, parseISO } from "@/shared";

export const mapDeliveryFromServer = getDataMapper({
    id: mapField("id"),
    updatedAt: mapField("updated_at", parseISO),
    title: mapField("title"),
    stateId: mapField("state_id", Number),
    status: mapField("state", {
        title: mapField("title"),
        color: mapField("color"),
        const: mapField("const"),
    }),
});

export const mapDeliveriesFromServer = mapArray(mapDeliveryFromServer);
